// extracted by mini-css-extract-plugin
export default {"wrapper":"w1npK","chart":"cFrsC","tooltipContainer":"GvmWy","tooltipWrapper":"UK_Dt","tooltipText":"wC8Px","question":"NT60e","questionsTitle":"Fl6hc","questionsContent":"_srDH"};